/*!
 * Copyright (c) 2024-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

// Code automatically generated; DO NOT EDIT.

import { forwardRef, memo } from "react";

import { SvgIcon, type SvgIconNoChildrenProps } from "../SvgIcon.js";

export type HideIconProps = SvgIconNoChildrenProps;

const HideIcon = forwardRef<SVGSVGElement, HideIconProps>((props, ref) => {
  return (
    <SvgIcon
      fill="none"
      ref={ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <>
        <path
          clipRule="evenodd"
          d="M12 3c2.353 0 4.267.745 5.791 1.786l-1.65 1.32A8.09 8.09 0 0 0 12 5C8.746 5 6.506 6.761 5.034 8.62A14.153 14.153 0 0 0 3.068 12a14.275 14.275 0 0 0 1.78 3.14l-1.561 1.25A16.256 16.256 0 0 1 1.2 12.714a10.039 10.039 0 0 1-.137-.362l-.008-.024-.002-.007-.001-.003c0-.001 0-.002.948-.318a91.698 91.698 0 0 1-.948-.317v-.004l.003-.007.008-.024.029-.08c.025-.067.06-.163.108-.282a16.15 16.15 0 0 1 2.266-3.907C5.16 5.24 7.92 3 12 3ZM2 12l-.949.316L.946 12l.105-.316L2 12Zm10-5c.835 0 1.623.205 2.315.567l-1.838 1.47a3 3 0 0 0-3.471 2.777l-1.84 1.472A5 5 0 0 1 12 7Zm2.992 4.787-3.858 3.086a3 3 0 0 0 3.858-3.087Zm-5.6 4.48L7.576 17.72A8.098 8.098 0 0 0 12 19c3.254 0 5.494-1.761 6.966-3.62A14.151 14.151 0 0 0 20.932 12a14.152 14.152 0 0 0-1.972-3.387l-2.224 1.779a5 5 0 0 1-7.344 5.875Zm11.13-8.904 2.603-2.082-1.25-1.562-20 16 1.25 1.562 2.818-2.255C7.508 20.165 9.508 21 12 21c4.08 0 6.84-2.239 8.534-4.38a16.147 16.147 0 0 0 2.266-3.906 10.026 10.026 0 0 0 .137-.362l.008-.024.002-.007.001-.003c0-.001 0-.002-.948-.318l.949.316.105-.316-.105-.316L22 12c.949-.316.949-.317.948-.317v-.004l-.003-.007-.008-.024a7.012 7.012 0 0 0-.137-.362 16.147 16.147 0 0 0-2.279-3.922Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </>
    </SvgIcon>
  );
});

const MemoizedHideIcon = memo(HideIcon);
MemoizedHideIcon.displayName = "HideIcon";

export { MemoizedHideIcon as HideIcon };
